const ID = 'download';

export default ID;
